export default __webpack_public_path__ + "static/media/2022_Juli_Pfad.a304a48f.webp";